var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"98%","background":"#fff","width":"98%","margin":"10px auto"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"img"},[_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setAi: _vm.setAi,
				getAi: _vm.getAi,
				setG5: _vm.setG5,
				getG5: _vm.getG5,
				setG4: _vm.setG4,
				getG4: _vm.getG4,
				setG2: _vm.setG2,
				getG2: _vm.getG2,
				setG3: _vm.setG3,
				getG3: _vm.getG3,
				setLight1: _vm.setLight1,
				getLight1: _vm.getLight1,
				setLight2: _vm.setLight2,
				getLight2: _vm.getLight2,
				setLine: _vm.setLine,
				getLine: _vm.getLine,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetAi,\n\t\t\t\tgetAi,\n\t\t\t\tsetG5,\n\t\t\t\tgetG5,\n\t\t\t\tsetG4,\n\t\t\t\tgetG4,\n\t\t\t\tsetG2,\n\t\t\t\tgetG2,\n\t\t\t\tsetG3,\n\t\t\t\tgetG3,\n\t\t\t\tsetLight1,\n\t\t\t\tgetLight1,\n\t\t\t\tsetLight2,\n\t\t\t\tgetLight2,\n\t\t\t\tsetLine,\n\t\t\t\tgetLine,\n\t\t\t}"}],attrs:{"id":"ai"}},[_c('img',{attrs:{"src":require("../assets/img/traffic/ai.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setAi: _vm.setAi,
				getAi: _vm.getAi,
				setG5: _vm.setG5,
				getG5: _vm.getG5,
				setG4: _vm.setG4,
				getG4: _vm.getG4,
				setG2: _vm.setG2,
				getG2: _vm.getG2,
				setG3: _vm.setG3,
				getG3: _vm.getG3,
				setLight1: _vm.setLight1,
				getLight1: _vm.getLight1,
				setLight2: _vm.setLight2,
				getLight2: _vm.getLight2,
				setLine: _vm.setLine,
				getLine: _vm.getLine,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetAi,\n\t\t\t\tgetAi,\n\t\t\t\tsetG5,\n\t\t\t\tgetG5,\n\t\t\t\tsetG4,\n\t\t\t\tgetG4,\n\t\t\t\tsetG2,\n\t\t\t\tgetG2,\n\t\t\t\tsetG3,\n\t\t\t\tgetG3,\n\t\t\t\tsetLight1,\n\t\t\t\tgetLight1,\n\t\t\t\tsetLight2,\n\t\t\t\tgetLight2,\n\t\t\t\tsetLine,\n\t\t\t\tgetLine,\n\t\t\t}"}],attrs:{"id":"light1"}},[_c('img',{attrs:{"src":require("../assets/img/traffic/light1.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setAi: _vm.setAi,
				getAi: _vm.getAi,
				setG5: _vm.setG5,
				getG5: _vm.getG5,
				setG4: _vm.setG4,
				getG4: _vm.getG4,
				setG2: _vm.setG2,
				getG2: _vm.getG2,
				setG3: _vm.setG3,
				getG3: _vm.getG3,
				setLight1: _vm.setLight1,
				getLight1: _vm.getLight1,
				setLight2: _vm.setLight2,
				getLight2: _vm.getLight2,
				setLine: _vm.setLine,
				getLine: _vm.getLine,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetAi,\n\t\t\t\tgetAi,\n\t\t\t\tsetG5,\n\t\t\t\tgetG5,\n\t\t\t\tsetG4,\n\t\t\t\tgetG4,\n\t\t\t\tsetG2,\n\t\t\t\tgetG2,\n\t\t\t\tsetG3,\n\t\t\t\tgetG3,\n\t\t\t\tsetLight1,\n\t\t\t\tgetLight1,\n\t\t\t\tsetLight2,\n\t\t\t\tgetLight2,\n\t\t\t\tsetLine,\n\t\t\t\tgetLine,\n\t\t\t}"}],attrs:{"id":"line"}},[_c('img',{attrs:{"src":require("../assets/img/traffic/line.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setAi: _vm.setAi,
				getAi: _vm.getAi,
				setG5: _vm.setG5,
				getG5: _vm.getG5,
				setG4: _vm.setG4,
				getG4: _vm.getG4,
				setG2: _vm.setG2,
				getG2: _vm.getG2,
				setG3: _vm.setG3,
				getG3: _vm.getG3,
				setLight1: _vm.setLight1,
				getLight1: _vm.getLight1,
				setLight2: _vm.setLight2,
				getLight2: _vm.getLight2,
				setLine: _vm.setLine,
				getLine: _vm.getLine,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetAi,\n\t\t\t\tgetAi,\n\t\t\t\tsetG5,\n\t\t\t\tgetG5,\n\t\t\t\tsetG4,\n\t\t\t\tgetG4,\n\t\t\t\tsetG2,\n\t\t\t\tgetG2,\n\t\t\t\tsetG3,\n\t\t\t\tgetG3,\n\t\t\t\tsetLight1,\n\t\t\t\tgetLight1,\n\t\t\t\tsetLight2,\n\t\t\t\tgetLight2,\n\t\t\t\tsetLine,\n\t\t\t\tgetLine,\n\t\t\t}"}],attrs:{"id":"light2"}},[_c('img',{attrs:{"src":require("../assets/img/traffic/light2.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setAi: _vm.setAi,
				getAi: _vm.getAi,
				setG5: _vm.setG5,
				getG5: _vm.getG5,
				setG4: _vm.setG4,
				getG4: _vm.getG4,
				setG2: _vm.setG2,
				getG2: _vm.getG2,
				setG3: _vm.setG3,
				getG3: _vm.getG3,
				setLight1: _vm.setLight1,
				getLight1: _vm.getLight1,
				setLight2: _vm.setLight2,
				getLight2: _vm.getLight2,
				setLine: _vm.setLine,
				getLine: _vm.getLine,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetAi,\n\t\t\t\tgetAi,\n\t\t\t\tsetG5,\n\t\t\t\tgetG5,\n\t\t\t\tsetG4,\n\t\t\t\tgetG4,\n\t\t\t\tsetG2,\n\t\t\t\tgetG2,\n\t\t\t\tsetG3,\n\t\t\t\tgetG3,\n\t\t\t\tsetLight1,\n\t\t\t\tgetLight1,\n\t\t\t\tsetLight2,\n\t\t\t\tgetLight2,\n\t\t\t\tsetLine,\n\t\t\t\tgetLine,\n\t\t\t}"}],attrs:{"id":"G1"}},[_c('img',{attrs:{"src":require("../assets/img/traffic/G1.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setAi: _vm.setAi,
				getAi: _vm.getAi,
				setG5: _vm.setG5,
				getG5: _vm.getG5,
				setG4: _vm.setG4,
				getG4: _vm.getG4,
				setG2: _vm.setG2,
				getG2: _vm.getG2,
				setG3: _vm.setG3,
				getG3: _vm.getG3,
				setLight1: _vm.setLight1,
				getLight1: _vm.getLight1,
				setLight2: _vm.setLight2,
				getLight2: _vm.getLight2,
				setLine: _vm.setLine,
				getLine: _vm.getLine,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetAi,\n\t\t\t\tgetAi,\n\t\t\t\tsetG5,\n\t\t\t\tgetG5,\n\t\t\t\tsetG4,\n\t\t\t\tgetG4,\n\t\t\t\tsetG2,\n\t\t\t\tgetG2,\n\t\t\t\tsetG3,\n\t\t\t\tgetG3,\n\t\t\t\tsetLight1,\n\t\t\t\tgetLight1,\n\t\t\t\tsetLight2,\n\t\t\t\tgetLight2,\n\t\t\t\tsetLine,\n\t\t\t\tgetLine,\n\t\t\t}"}],attrs:{"id":"G5"}},[_c('img',{attrs:{"src":require("../assets/img/traffic/G5.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setAi: _vm.setAi,
				getAi: _vm.getAi,
				setG5: _vm.setG5,
				getG5: _vm.getG5,
				setG4: _vm.setG4,
				getG4: _vm.getG4,
				setG2: _vm.setG2,
				getG2: _vm.getG2,
				setG3: _vm.setG3,
				getG3: _vm.getG3,
				setLight1: _vm.setLight1,
				getLight1: _vm.getLight1,
				setLight2: _vm.setLight2,
				getLight2: _vm.getLight2,
				setLine: _vm.setLine,
				getLine: _vm.getLine,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetAi,\n\t\t\t\tgetAi,\n\t\t\t\tsetG5,\n\t\t\t\tgetG5,\n\t\t\t\tsetG4,\n\t\t\t\tgetG4,\n\t\t\t\tsetG2,\n\t\t\t\tgetG2,\n\t\t\t\tsetG3,\n\t\t\t\tgetG3,\n\t\t\t\tsetLight1,\n\t\t\t\tgetLight1,\n\t\t\t\tsetLight2,\n\t\t\t\tgetLight2,\n\t\t\t\tsetLine,\n\t\t\t\tgetLine,\n\t\t\t}"}],attrs:{"id":"G2"}},[_c('img',{attrs:{"src":require("../assets/img/traffic/G2.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setAi: _vm.setAi,
				getAi: _vm.getAi,
				setG5: _vm.setG5,
				getG5: _vm.getG5,
				setG4: _vm.setG4,
				getG4: _vm.getG4,
				setG2: _vm.setG2,
				getG2: _vm.getG2,
				setG3: _vm.setG3,
				getG3: _vm.getG3,
				setLight1: _vm.setLight1,
				getLight1: _vm.getLight1,
				setLight2: _vm.setLight2,
				getLight2: _vm.getLight2,
				setLine: _vm.setLine,
				getLine: _vm.getLine,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetAi,\n\t\t\t\tgetAi,\n\t\t\t\tsetG5,\n\t\t\t\tgetG5,\n\t\t\t\tsetG4,\n\t\t\t\tgetG4,\n\t\t\t\tsetG2,\n\t\t\t\tgetG2,\n\t\t\t\tsetG3,\n\t\t\t\tgetG3,\n\t\t\t\tsetLight1,\n\t\t\t\tgetLight1,\n\t\t\t\tsetLight2,\n\t\t\t\tgetLight2,\n\t\t\t\tsetLine,\n\t\t\t\tgetLine,\n\t\t\t}"}],attrs:{"id":"G4"}},[_c('img',{attrs:{"src":require("../assets/img/traffic/G4.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setAi: _vm.setAi,
				getAi: _vm.getAi,
				setG5: _vm.setG5,
				getG5: _vm.getG5,
				setG4: _vm.setG4,
				getG4: _vm.getG4,
				setG2: _vm.setG2,
				getG2: _vm.getG2,
				setG3: _vm.setG3,
				getG3: _vm.getG3,
				setLight1: _vm.setLight1,
				getLight1: _vm.getLight1,
				setLight2: _vm.setLight2,
				getLight2: _vm.getLight2,
				setLine: _vm.setLine,
				getLine: _vm.getLine,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetAi,\n\t\t\t\tgetAi,\n\t\t\t\tsetG5,\n\t\t\t\tgetG5,\n\t\t\t\tsetG4,\n\t\t\t\tgetG4,\n\t\t\t\tsetG2,\n\t\t\t\tgetG2,\n\t\t\t\tsetG3,\n\t\t\t\tgetG3,\n\t\t\t\tsetLight1,\n\t\t\t\tgetLight1,\n\t\t\t\tsetLight2,\n\t\t\t\tgetLight2,\n\t\t\t\tsetLine,\n\t\t\t\tgetLine,\n\t\t\t}"}],attrs:{"id":"G3"}},[_c('img',{attrs:{"src":require("../assets/img/traffic/G3.png"),"alt":""}})])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"button"},[_vm._v("进入CocoBlockly编程平台")]),_vm._v(" "),_c('video',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"id":"musicC","src":require('../assets/music/click.mp3')}})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tip"},[_c('img',{attrs:{"src":require("../assets/img/traffic/tips.png"),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"right"},[_c('img',{attrs:{"src":require("../assets/img/right.png"),"alt":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4be8759a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/traffic.vue
// module id = null
// module chunks = 